export const surveyThemeLight = {
  themeName: "default",
  colorPalette: "light",
  isPanelless: false,
  cssVariables: {
    "--sjs-corner-radius": "8px",
    "--sjs-primary-backcolor": "rgb(39, 94, 196)",
    "--sjs-general-backcolor-dim": "#EAF0F8",
    "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.65)",
  },
  headerView: "basic" as const,
};

export const surveyThemeDark = {
  ...surveyThemeLight,
  colorPalette: "dark",
  cssVariables: {
    ...surveyThemeLight.cssVariables,
    "--sjs-primary-backcolor": "#6b9cff",
    "--sjs-general-backcolor-dim": "#222222",
    "--sjs-general-forecolor-light": "rgba(255, 255, 255, 0.8)",
    "--sjs-general-forecolor": "rgba(255, 255, 255, 1)",

    // Default
    "--sjs-border-default": "rgba(255, 255, 255, 0.12)",
    "--sjs-border-light": "rgba(255, 255, 255, 0.08)",
    "--sjs-general-backcolor": "rgba(48, 48, 48, 1)",
    "--sjs-general-backcolor-dark": "rgba(52, 52, 52, 1)",
    "--sjs-general-backcolor-dim-light": "rgba(43, 43, 43, 1)",
    "--sjs-general-backcolor-dim-dark": "rgba(46, 46, 46, 1)",
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.79)",
    "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.45)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-border-inside": "rgba(255, 255, 255, 0.08)",
    "--sjs-special-red-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-special-green": "rgba(36, 197, 164, 1)",
    "--sjs-special-green-light": "rgba(36, 197, 164, 0.1)",
    "--sjs-special-green-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-special-blue": "rgba(91, 151, 242, 1)",
    "--sjs-special-blue-light": "rgba(91, 151, 242, 0.1)",
    "--sjs-special-blue-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
    "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-special-yellow-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-primary-backcolor-dark": "rgba(101, 147, 240, 1)",
    "--sjs-primary-backcolor-light": "rgba(107, 156, 255, 0.1)",
    "--sjs-primary-forecolor": "rgba(32, 32, 32, 1)",
    "--sjs-primary-forecolor-light": "rgba(32, 32, 32, 0.25)",
    "--sjs-special-red": "rgba(254, 76, 108, 1)",
    "--sjs-special-red-light": "rgba(254, 76, 108, 0.1)",
  },
};
